import { AppComponent } from "~core/AppComponent.js";
export class Instruction extends AppComponent {
  constructor($root, options) {
    super($root, {
      name: "Instruction",
      ...options,
    });
  }
  static className = ["app__Instruction", "article"];
  toHTML() {
    return `
    <h5>Install</h5>
    Create tooltip experiance in pure javascript.
    <pre><code class="language-npm">
    npm install @kamenskii/tooltip --save
  </code></pre>

    <h5>Import/ES6</h5>
    <pre class="language-javascript"><code class="language-javascript">
    import Tooltip from '@kamenskii/tooltip';
    import "@kamenskii/tooltip/dist/umd/tooltip.css";
  </code></pre>

  <h5>Initialization</h5>
  <pre class="language-javascript"><code class="language-javascript">
   var instance = new Tooltip('.element', options)
   
</code></pre>

<h3>Methods</h3>

<h5>.open</h5>
Show tooltip.<br>
<code class="language-javascript">
instance.open('html');
</code>

<h5>.close</h5>
Hide tooltip.<br>
<code class="language-javascript">
instance.close();
</code>

<h5>.destroy</h5>
Destroy plugin instance and teardown.<br>
<code class="language-javascript">
instance.destroy();
</code>


<table class="striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Default</th>
              <th>Description</th>
            </tr>
          </thead>

<h3>Options</h3>
          <tbody>
            <tr>
              <td>margin</td>
              <td>Number</td>
              <td>10</td>
              <td>Set distance tooltip appears away from its activator.</td>
            </tr>
            <tr>
              <td>position</td>
              <td>String</td>
              <td>'left'</td>
              <td>Set the direction of the tooltip. 'top', 'right', 'bottom', 'left'.</td>
            </tr>
            <tr>
            <td>arrowPosition</td>
            <td>String</td>
            <td>'center'</td>
            <td>Set the direction of arrow. 'top', 'right', 'bottom', 'left'.</td>
          </tr>
            <tr>
              <td>tooltipMove</td>
              <td>Boolian</td>
              <td>false</td>
              <td>tooltip move.</td>
            </tr>
            <tr>
              <td>cross</td>
              <td>Boolian</td>
              <td>false</td>
              <td>cross for close tooltip</td>
            </tr>
            <tr>
            <td>arrow</td>
            <td>Boolian</td>
            <td>false</td>
            <td>add arrow</td>
          </tr>
            <tr>
              <td>class</td>
              <td>String</td>
              <td>''</td>
              <td>add tooltip class</td>
            </tr>
          </tbody>
        </table>


    `;
  }
}
